import React from "react";
import { connect } from 'react-redux'

import { teachersActions } from '../actions';

import { personasActions } from '../../personas/actions' ;

import { Spinner } from 'components/Icons/Spinner';
import { Col, Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import { Link } from 'react-router-dom';
import '../components/styles.css';
import { CourseStudentEvalCard } from '../components/CourseStudentEvalCard';

var Utils = require ('Utils');
var Const = require ('Const');



var viewActions = require ('store/view.actions');

class StudentSubjectPage extends React.Component {

  componentDidMount() {
    this.props.getCourseSubject (this.props.token,  this.props.match.params.course_subject_id) ;
    this.props.getCourseEvals( this.props.token,  this.props.match.params.course_subject_id); 
    this.props.getPersona (this.props.token,  this.props.match.params.student_id ) ;
    this.props.getCourseSubjectStudentsEvals( this.props.token,  this.props.match.params.course_subject_id, this.props.match.params.student_id);

  }

  constructor(props) {
    super(props);
    this.state = {
    }

 }


 
  render() {
    return (
      <>
        <div className="content">
        {this.props.courseSubject.course_subject_id && !this.props.view.loadingModules.getCourseSubject ?
            <Card
              className={ "cover-image-card"}
              style={{ backgroundImage: 'url("' + (this.props.courseSubject.cover_image?this.props.courseSubject.cover_image:Utils.defaultCover()) + '")' }}
            >

               <CardHeader>
               <div class="float-right">
                   <Link className="btn"
                      to={"/admin/my-courses/"+this.props.courseSubject.course_subject_id}  >
                    Volver al curso 
                  </Link>
                </div>

                <p className="student-page-header">
                  {!this.props.view.loadingModules.getPersona ?
                  <>
                  <img
                      alt="..."
                      className="avatar-page border-gray "
                      src={this.props.student.image?this.props.student.image:Const.DEFAULT_IMAGE_PROFILE[(this.props.student.gender?this.props.student.gender:'O')]}
                      />
                      {Utils.capitalize(this.props.student.name + " " + this.props.student.last_name)}
                      </>
                      :
                      <Spinner />
                  }
                  </p>
                  <p className="h5">
                    {Utils.capitalize(this.props.courseSubject.subject_name)} - 
                    {Utils.capitalize(this.props.courseSubject.course_short_name)} -
                    Turno {this.props.courseSubject.shift_name} 
                  </p>

              </CardHeader>
             
              <CardBody>
                     <Col md="6" >
                    { 
                      this.props.courseStudentEvals.map( (csEval,idx) => {

                      return ( 
                            
                              !this.props.view.loadingModules.getCourseSubjectStudentsEvals?
                                <CourseStudentEvalCard
                                  csEval={csEval}
                                  courseEvals={this.props.courseEvals}
                                  updateEvals={this.props.updateCourseSubjectStudentsEvals}
                                  createEval={this.props.addCourseSubjectStudentsEvals}
                                  delEval={this.props.deleteCourseSubjectStudentsEvals}
                                  token={this.props.token}
                                  persona={this.props.student}
                                  isPreviousCompleted={idx>0?
                                    (this.props.courseStudentEvals[idx-1].qualif_value_id ||
                                      this.props.courseStudentEvals[idx-1].qualif_value_nbr)
                                    :true}
                                  />
                                :
                                <Spinner />
                              
                          
                      )
                    } )}
                  </Col> 
               </CardBody>
             <CardFooter>
                 <hr />
                
               </CardFooter>
             </Card>
            
        :
        <Spinner size="XL" />
      }
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user,
        courseSubject: state.teachers.courseSubject,
        student: state.personas.persona,
        courseStudentEvals: state.teachers.courseStudentEvals,
        courseEvals: state.teachers.courseEvals
        
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getCourseSubject: (token, courseSubjectID) => {
            dispatch(teachersActions.getCourseSubject(token, courseSubjectID));
        } , 
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        getPersona: ( token, studentID, calendarID ) => {
          dispatch( personasActions.getPersona( token, studentID ) )
        },
        getCourseEvals: ( token, courseSubjectID ) => {
          dispatch( teachersActions.getCourseEvals( token, courseSubjectID ))
        },
        getCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID ) => {
          dispatch( teachersActions.getCourseSubjectStudentsEvals( token, courseSubjectID, personaID ))
        },
        updateCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID, data, qualifValue ) => { 
          dispatch( teachersActions.updateCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, data, qualifValue ) )
        },
        addCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID, qualifValue ,qualifValueNbr,  comments ) => {
          dispatch( teachersActions.addCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, qualifValue,qualifValueNbr , comments ))
        },
        deleteCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID ) => { 
          dispatch( teachersActions.deleteCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID ) )
        }



    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(StudentSubjectPage);

